<template>
<div>    
    <base-header v-once pageName="영업활동계획" :prevBtnShow="true" history="main"></base-header>
    
    <section id="wrap">
        <ul class="tab tab-fix">
            <li><button type="button" @click="bsnPlnList()">지국 영업활동계획</button></li>
            <li><button type="button" class="current">소속 조직원 계획</button></li>
        </ul>
        <div class="search head">
                <base-selectbox selectName="년도 선택"
                    :default="thisYr"
                    :only="false"
                    v-on:selectSearch="year" 
                    :options="makeSelect(2021)"
                ></base-selectbox>
              
             
                   <base-selectbox selectName="월 선택"
                    :default="thisMn+'월'"
                    :only="false"
                    v-on:selectSearch="month"
                    :options="[
                        {text:'01월',value:'01'},
                        {text:'02월',value:'02'},
                        {text:'03월',value:'03'},
                        {text:'04월',value:'04'},
                        {text:'05월',value:'05'},
                        {text:'06월',value:'06'},
                        {text:'07월',value:'07'},
                        {text:'08월',value:'08'},
                        {text:'09월',value:'09'},
                        {text:'10월',value:'10'},
                        {text:'11월',value:'11'},
                        {text:'12월',value:'12'}
                    ]" 
                ></base-selectbox>
          
            <button type="button" class="selected"  @click="searchList">조회</button>
            
            <input type="search" v-model="searchTxt" class="search" placeholder="이름, 사번을 입력하세요.">

                <base-selectbox selectName="조직원 선택"
                :valName="''"  
                 :default="''"
                  v-on:selectSearch="selectPstn"
                :only="false"              
                :options="orgOptnList" 
            ></base-selectbox>
               
        </div>


        <div class="bsnsAcpln-list" v-for="(item , i) in list" v-bind:key="item.planYrmn">
            <h5>{{item.planYr}}년 {{item.planMn}}월</h5>

            <template v-if="isNotEmpty || canReqYrmn === item.planYr+item.planMn && canReq === 'Y'"> 
                <template v-if="canReqYrmn === item.planYr+item.planMn && canReq === 'Y'">
                    <ul>
                        <template  v-for="(orgItem , o) in item.orgMember">
                            <li v-bind:key="orgItem.sqno" v-if="orgItem.pstn != 'COG06'">
                                <template v-if="orgItem.sqno === undefined">
                                    <p>
                                        <em :class="pstnChk(orgItem.pstn)"></em>
                                        <strong>{{orgItem.userName}}</strong>
                                        <span>{{orgItem.userId}}</span>
                                    </p>
                                    <button v-if="orgItem.stat === 'S'" type="button" @click="reqBsnPln(i , o )">요청하기</button>
                                    <button v-if="orgItem.stat === 'R'" type="button" disabled>요청 중</button>
                                </template>
                                <template v-else>
                                    <p @click="bsnPlnDetail(orgItem.sqno)">
                                        <em :class="pstnChk(orgItem.pstn)"></em>
                                        <strong>{{orgItem.userName}}</strong>
                                        <span>{{orgItem.userId}}</span>
                                    </p>
                                    <template  v-if="orgItem.stat === 'R'">
                                        <button type="button" disabled>요청 중</button>
                                    </template>
                                    <template v-else>
                                        <strong>{{orgItem.amtSum | numFormat}}만원</strong>
                                    </template>
                                </template>
                            </li>
                        </template>
                    </ul>
                </template> 
                <template v-else>
                    <ul>
                        <template  v-for="orgItem in item.orgMember">
                            <li v-bind:key="orgItem.sqno" v-if="orgItem.stat != 'S' && orgItem.pstn != 'COG06'">
                                <template v-if="orgItem.sqno === undefined">
                                    <p>
                                        <em :class="pstnChk(orgItem.pstn)"></em>
                                    <span>{{orgItem.userName}}</span>
                                        <span>{{orgItem.userId}}</span>
                                    </p>
                                    <strong>{{orgItem.amtSum | numFormat}}만원</strong>
                                </template>
                                <template v-if="orgItem.sqno != undefined ">
                                    <p @click="bsnPlnDetail(orgItem.sqno)">
                                        <em :class="pstnChk(orgItem.pstn)"></em>
                                        <strong>{{orgItem.userName}}</strong>
                                        <span>{{orgItem.userId}}</span>
                                    </p>
                                    <strong>{{orgItem.amtSum | numFormat}}만원</strong>
                                </template>
                            </li>
                        </template>
                    </ul>
                </template>
            </template>
            <template v-else>
                 <ul>
                    <div class="bsnsAcpln-list dataNone">
                        검색된 영업활동 계획이 없습니다.
                    </div>
                 </ul>
            </template>
        </div>
         <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
            <div slot="no-more"></div>
            <div slot="no-results">
                <div class="bsnsAcpln-list dataNone">
                    검색된 영업활동 계획이 없습니다.
                </div>
            </div>
            </infinite-loading> 

    </section>
</div>
</template>

<script>

import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "HeadBsnPlnList",
  components: {
    InfiniteLoading,   
  },

  data() {
      return{
        planYr : '',
        planMn : '',
        thisYr : '',
        thisMn : '',
        thisDy : '',
        sqno : '',
        list:[],
        tot:0,
        offset: 0,     //현재 가지고있는 갯수
        size : 10 ,  //한번에 가져오는 수
        pstnTyp : this.$store.getters.orgnzPstn,
        isNotEmpty : false,
        searchYear : '',
        searchMonth : '',
        searchTxt : '',
        searchPstn : '',
        firstEndDt : '',
        fourthEndDt : '',
        firstSttDt : '',
        canReq : 'N',
        canReqYrmn : '',
        orgOptnList:[]

      };
  },
    methods: {
        infiniteHandler : function($state){
			console.log('SCROLL')
            var that = this;
            var parameters = {
                offset: this.offset,
                size: this.size,
                searchYear : this.searchYear,
                searchMonth : this.searchMonth,
                searchTxt : this.searchTxt,
                searchPstn : this.searchPstn
            };
            this.$api.mypage
                .headBsnPlnList(parameters)
                .then(function(data) {
                    that.tot = data.totCnt;  // API에서 가져온 총 카운트
                    var list = data.list;   //API에서 가져온 리스트

                    if (list.length) {
                        that.list = that.list.concat(list);
                        $state.loaded();
                        that.offset += that.size;

                        if (list.length < that.size) {
                        $state.complete();
                        }
                    } else {
                        $state.complete();
                    }
                    var orgMem = list[0].orgMember;
                    for (var i = 0 ; i < orgMem.length ; i++) {
                        if(orgMem[i].stat !='S') {
                            that.isNotEmpty = true;
                        }
                    }

                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        makeSelect: function(openYr){ //년도 셀렉트박스 생성
            
            var selectDate = new Date();
            var selectYear = selectDate.getFullYear();
            var yearList = []; //날짜
            for (var i = 0 ; i <= selectYear - openYr ; i++) {
                var option = {text : selectYear-i , value : selectYear-i  }
                yearList.push(option);
            }
            return yearList;
        },

        year: function(val){
            this.searchYear = val;
        },
        month: function(val){
            this.searchMonth = val;
        },
        selectPstn: function(val){
            this.searchPstn = val;
        },
        searchList : function(){
			this.totalCnt = 0
			this.offset = 0
			this.size = 10
			this.list = []
            this.isNotEmpty = false;
			this.$refs.InfiniteLoading.stateChanger.reset(); 
		},
        reqBsnPln : function(i , o){  //지국장 권한 영업활동계획 요청하기

            if(confirm("영업활동계획을 요청 하시겠습니까?")){
                var that = this;
                var parameters = {
                    userId : this.list[i].orgMember[o].userId,
                    planYr : this.list[i].planYr,
                    planMn : this.list[i].planMn
                };
                this.$api.mypage
                .reqBsnPln(parameters)
                .then(function(data) {
                    if(data){
                       that.list[i].orgMember[o].stat = "R";
                    }
                })
                .catch(function(error) {
                    alert(error.rtMsg);
                });
            }
        },
        bsnPlnDetail: function(sqno){
            this.$utils.nativeIf.outbound.newPage("/mypage/bsnPlnMemberDetail?sqno="+sqno)  //새창 띄우기
        },
        bsnPlnList: function(){
        this.$router.push('/mypage/bsnPlnList'); 
        },    
        pstnChk : function(pstn){
            var pstnChkFlag;
            if (pstn == 'COG02'){
                pstnChkFlag = 'epLv1'; //지구장
            }else if (pstn == 'COGA2'){
                pstnChkFlag = 'epLvA1'; //마스터
            }else if (pstn == 'COG03'){
                pstnChkFlag = 'epLv2'; //프로
            }else if (pstn == 'COG04'){
                pstnChkFlag = 'epLv3'; //일반
            }else if (pstn == 'COG05'){
                pstnChkFlag = 'epLv4'; //파트너
            }
                return pstnChkFlag;
        }
  },
    filters:{
		numFormat:function(num){
			if(num==0) return 0;

			var n = num+'';
			var reg = /(^[+-]?\d+)(\d{3})/;

			while (reg.test(n))
				n = n.replace(reg,'$1'+','+'$2');
			
			return n;
		}
	},
    created : function(){
        this.orgOptnList.push({text:'조직원 전체',value:''});
        this.orgOptnList.push({text:'마스터',value:'COGA2'});
        this.orgOptnList.push({text:'1급',value:'COG03'});
        this.orgOptnList.push({text:'2급',value:'COG04'});
        this.orgOptnList.push({text:'3급',value:'COG05'});
		this.orgOptnList.push({text:'파트너',value:'COG06'});

        var firstDayOfPreMon = new Date();

        var yearOfPreMon = firstDayOfPreMon.getFullYear() +'';
		var monthOfPreMon = ((firstDayOfPreMon.getMonth() + 1) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() + 1);
        var dayOfPreMon = ("00"+(firstDayOfPreMon.getDate() )).slice(-2); // 일 (2자리)
        
        this.thisYr = yearOfPreMon;
        this.thisMn = monthOfPreMon;
        this.thisDy = dayOfPreMon;
        
        this.searchYear = yearOfPreMon;
        this.searchMonth = monthOfPreMon;

        var nextYr = '';
        var nextMn = '';

        //this.canReqYrmn = yearOfPreMon + monthOfPreMon;   // 추후 제거해야됨 (일시적으로 등록불가 해제)

        if ((firstDayOfPreMon.getMonth() + 2) > 12) {
            //이월
            nextYr = (firstDayOfPreMon.getFullYear()+1)+'';
            nextMn = ((firstDayOfPreMon.getMonth() -10) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() -10)
        } else {
            nextYr = yearOfPreMon;
            nextMn = ((firstDayOfPreMon.getMonth() + 2) < 10 ? '0' : '') + (firstDayOfPreMon.getMonth() + 2);
        }

        var that = this;
        var parameters = {
            thisYrmn : yearOfPreMon + monthOfPreMon,
            nextYrmn : nextYr + nextMn
        };
        this.$api.mypage
        .sttEndInfo(parameters)
        .then(function(data) {
            
            that.firstEndDt = data.firstEndDt;
            that.fourthEndDt = data.fourthEndDt;

            if(data.firstSttDt){
                that.firstSttDt = data.firstSttDt;
                if(data.firstSttDt > that.thisYr+that.thisMn+that.thisDy &&  data.fourthEndDt <= that.thisYr+that.thisMn+that.thisDy) { //다음달 요청 가능 (4구간 마감 ~ 다음달 1구간 시작)
                    that.canReq = 'Y';
                    that.canReqYrmn = nextYr + nextMn;
                }
            }  else {
                
                if (data.thisFirstSttDt  >= that.thisYr+that.thisMn+that.thisDy) {
                    that.canReq = 'Y';
                    that.canReqYrmn = yearOfPreMon + monthOfPreMon;
                }
            }

            if(data.firstEndDt <= that.thisYr+that.thisMn+that.thisDy &&  data.firstEndDt2 >= that.thisYr+that.thisMn+that.thisDy) {//이번달 요청 가능 (1구간 마감)
                that.canReq = 'Y';
                that.canReqYrmn = yearOfPreMon + monthOfPreMon;
            }
        })
        .catch(function(error) {
            alert(error.rtMsg);
        });


    },      
};
</script>